module.exports = __webpack_public_path__ + "static/media/schedule_structure_remove_a_period.aff79122.mov";